// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d7359359","977":"2e3d5464"}[chunkId] + ".chunk.js";
};